namespace Matrix.Administration {
    export interface PermissionSetPermissionListRequest extends Serenity.ServiceRequest {
        PermissionSetCodes?: string[];
    }
}
